export default {
  report_id_label: "ID du rapport",
  report_id_placeholder: "Saisir l'ID du rapport pour rechercher",
  type_label: "Type",
  type_placeholder: "Sélectionner le type",
  shared_label: "Partagé",
  shared_placeholder: "Sélectionner le statut de partage",
  report_id: "ID du rapport",
  date: "Date",
  report_type: "Type de rapport",
  created_at: "Créé le",
  shared: "Partagé",
  actions: "Actions",
  view_count: "Nombre de vues",
  regenerate: "Régénérer",
  delete_confirm: "Êtes-vous sûr de vouloir supprimer ce rapport ?",
  copied: "Lien copié dans le presse-papiers",
  copied_with_expire: "Lien copié dans le presse-papiers, expirera le {date}",
  copy_failed: "Échec de la copie du lien",
  share_failed: "Échec du partage",
  report_detail: "Détail du rapport",
  preview_title: "Aperçu du rapport",
  data_format_error: "Erreur de format de données",
  plan_changed_notice:
    "Votre plan a été modifié, utilisant maintenant le dernier plan ({planType}) pour afficher ce rapport.",
  config_changed_notice:
    "Votre configuration a été modifiée, utilisant maintenant la dernière configuration pour afficher ce rapport.",
  calculation_deleted_notice: "Certains calculs ont été supprimés.",
  delete_success: "Supprimé avec succès",
  not_found_title: "Rapport introuvable",
  not_found_desc: "Le rapport que vous recherchez n'existe pas",
  share: "Partager",
  copy_link: "Copier le lien",
  share_to_x: "Partager sur X",
  share_to_linkedin: "Partager sur LinkedIn",
  unshare: "Annuler le partage",
  unshare_success: "Partage du rapport annulé avec succès",
  unshare_failed: "Échec de l'annulation du partage du rapport",
  shared_expires_at: "Le partage expire le",
  privacy_fields_hidden:
    "Les champs de confidentialité sont masqués par défaut, peuvent être modifiés dans Paramètres - Configuration du rapport, les modifications prennent effet immédiatement",
  want_to_calculate:
    "Vous souhaitez calculer votre propre taxe carbone CBAM ? Obtenez 50 calculs après le premier calcul",
  register_free: "Inscription gratuite",
  use_invitation_code: "Utiliser le code d'invitation",
  failed_to_load_shared_report: "Échec du chargement du rapport partagé",
  report_data_missing: "Les données du rapport sont manquantes",
  unable_to_get_shared_report: "Impossible d'obtenir les données du rapport partagé",
  carbon_emission_report: "Rapport d'émission de carbone",
  check_out_carbon_emission: "Découvrez ce rapport d'émission de carbone",
};
